// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-pages-business-components-FormContent-components-DefaultContent-__index__wrap--354mz"};